export default __webpack_public_path__ + "static/media/loader3.e22f6a76.jpg";